﻿/* globals  google */

var jquery = require('jquery');

(function () {
    "use strict";

    var MapaGoogle = function (mapaGoogleDTO) {
        this.__GMapsConfig = mapaGoogleDTO;
        this.__isMapInitialized = false;
        this.__isStreetViewInitalized = false;
        this.__googleMapObject = null;
        this.__googleMapObjetStreetView = null;
        __checkHasStreetView.call(this);
    };

    var __initializeMap = function () {

        if (!this.__isMapInitialized) {
            
            this.__googleMapObject = __initGoogleMapObject.call(this, this.__GMapsConfig.mapsContainerId);

            
            this.__isMapInitialized = true;
        }
    };

    var __initializeStreetView = function () {

        if (!this.__isStreetViewInitalized) {

            var position = new google.maps.LatLng(this.__GMapsConfig.VGPSLat, this.__GMapsConfig.VGPSLon);

            var panoramaOptions = {
                position: position,
                pov: {
                    heading: this.__GMapsConfig.StreetView.heading || 34,
                    pitch: this.__GMapsConfig.StreetView.pitch || 10,
                    zoom: this.__GMapsConfig.StreetView.zoom || 1
                }
            };

            this.__googleMapObjetStreetView = __initGoogleMapObject.call(this, this.__GMapsConfig.streetViewContainerId);

            var panorama = new google.maps.StreetViewPanorama(
                    document.getElementById(this.__GMapsConfig.streetViewContainerId),
                    panoramaOptions);

            this.__googleMapObjetStreetView.setStreetView(panorama);

            this.__isStreetViewInitalized = true;
        }
    };


    var __initGoogleMapObject = function (mapsContainerId) {
        var position = new google.maps.LatLng(this.__GMapsConfig.VGPSLat, this.__GMapsConfig.VGPSLon);

        var myMapStyleDef = [
            {
                featureType: "poi.business",
                elementType: "labels.text",
                stylers: [
                    { visibility: "off" }
                ]
            }
        ];

        var myMapStyle = new google.maps.StyledMapType(myMapStyleDef,
            { name: "Mapa" }
        );

        var myOptions = {
            mapTypeControlOptions: {
                mapTypeIds: ["myMapStyle", google.maps.MapTypeId.HYBRID]
            },
            zoom: this.__GMapsConfig.zoom,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            center: position,
            mapTypeId: "myMapstyle",
            scrollwheel: true,
            streetViewControl: false,
            gestureHandling: 'greedy'
        };

        var googleMapObject = new google.maps.Map(document.getElementById(mapsContainerId), myOptions);
        googleMapObject.mapTypes.set("myMapStyle", myMapStyle);
        googleMapObject.setMapTypeId("myMapStyle");

        google.maps.InfoWindow.prototype.setContent = function () {
            var that = this;
            setTimeout(function () { that.close(); }, 200);
        };
        if (this.__GMapsConfig.mostrarHab === 1) {
            new google.maps.Marker({
                position: position,
                map: googleMapObject,
                icon: this.__GMapsConfig.urlMarker,
                draggable: false
            });
        }

        return googleMapObject;
    };

    var __checkHasStreetView = function () {
        if (this.__GMapsConfig && typeof google !== 'undefined' && google.maps) {
            var gMPosition = new google.maps.LatLng(this.__GMapsConfig.VGPSLat, this.__GMapsConfig.VGPSLon);
            var streetViewService = new google.maps.StreetViewService();
            var STREETVIEW_MAX_DISTANCE = 25;
            streetViewService.getPanoramaByLocation(gMPosition, STREETVIEW_MAX_DISTANCE, function (streetViewPanoramaData, status) {
                if (status === google.maps.StreetViewStatus.OK) {
                    jquery("#li-streetview").show();
                }
            });
        }
    };

    MapaGoogle.prototype = {
        constructor: MapaGoogle,
        InitializeMap: __initializeMap,
        InitializeStreetView: __initializeStreetView
    };

    if (typeof module !== 'undefined' && module.exports) {
        /*jshint undef: false*/
        module.exports = MapaGoogle;
    }
    else {
        window.MapaGoogle = MapaGoogle;
    }

})();